import { useAuth } from "~utils/hooks/use-auth"
import { useGetUserQuery } from "~graphql/users.generated"

export function useUser() {
    const { isAuthenticated, error: authError } = useAuth()

    const {
        loading: isLoading,
        data,
        error: userError,
    } = useGetUserQuery({
        skip: !isAuthenticated,
        variables: {},
    })

    const error = authError || userError
    const user = data?.user

    // Some of the flags above also exist in `user-provider`.
    // Can we move them all here to be used outside of the provider?
    const isAdmin = Boolean(user?.is_admin)
    const isImpersonating = Boolean(
        user?.impersonation_details?.is_impersonated
    )
    const isAdminNotImpersonating = isAdmin && !isImpersonating

    return { user, isLoading, error, isAdminNotImpersonating }
}
